interface Config {
    API_AUTH_URL: string;
    SERVER_URL: string;
    API_URL: string;
    API_PERMISSION_URL:string;
    PAGE_SIZE: number;
    PERMISSION_CODE: string;
    API_LABELING_URL: string;
}

const config: Config = {
    API_AUTH_URL: `${process.env.REACT_APP_API_AUTH_URL}`,
    SERVER_URL: `${process.env.REACT_APP_SERVER_URL}`,
    API_URL: `${process.env.REACT_APP_API_URL}`,
    API_PERMISSION_URL: `${process.env.REACT_APP_API_PERMISSION_URL}`,
    PAGE_SIZE: parseInt(`${process.env.REACT_APP_PAGE_SIZE}`),
    PERMISSION_CODE: `${process.env.REACT_APP_PERMISSION_CODE}`,
    API_LABELING_URL: `${process.env.REACT_APP_API_LABELING_URL}`
};

export default config;


